<ng-container *transloco="let tloco; prefix: 'subscriptions.my-subscription'">
  @if (!hidePageHeader) {
    <rma-page-header [title]="tloco('title')" />
  }

  @if (subscription$ | async; as subscription) {
    <div class="container-padding">
      @if (profile$ | async; as profile) {
        <rma-billing-info-nav
          class="mb-6 block"
          [subscription]="subscription"
          [agencyName]="profile.parentName"
          [profileName]="profile.fullName"
          [agentCount]="(agentCount$ | async) ?? 0"
        />
      }
      <mat-card class="px-4 py-6 md:p-8" [class.bg-purple-10!]="subscription.isFree">
        @if (!subscription.isFree) {
          <div class="flex flex-col">
            @if (goodPerformance$ | async) {
              <div class="flex items-start md:items-center">
                <img alt="" class="h-8 w-8" [src]="'dashboard/icons/confetti-yellow.svg' | staticImageUrl" />
                <span class="ml-4 text-heading-2">{{ tloco('good-performance') }}</span>
              </div>
              <span class="mt-6">{{ tloco('last-12-months') }}</span>
            } @else {
              <span class="text-heading-2">{{ tloco('activity') }}</span>
            }
            <div class="flex flex-col gap-y-6 pt-3 md:grid md:grid-cols-2 md:gap-6">
              <rma-my-subscription-review-channels-card
                *rmaLet="externalPlatformsWithReviews$ as externalPlatformsWithReviews; suspenseRef: cardIsLoading"
                [displayPlatforms]="externalPlatformsWithReviews"
                [hasRmaReviews]="!!(rmaReviewCount$ | async)"
              />
              @if ((rmaTileLoading$ | async) === false) {
                <rma-my-subscription-reviews-card [reviews]="rmaReviewCount$ | async" [exposures]="rmaExposures$ | async" />
              } @else {
                <rma-my-subscription-is-loading-card />
              }
              @if (externalReviewPlatform$ | async; as platform) {
                <ng-container *rmaLet="realtorDomainExposures$ as realtorDomainExposures; suspenseRef: cardIsLoading">
                  @if (realtorDomainExposures.convertedReviews > 0) {
                    <rma-my-subscription-integration-card
                      [platform]="platform"
                      [platformIcon]="platformIcon$ | async"
                      [reviewInfo]="realtorDomainExposures"
                    />
                  }
                </ng-container>
              }
              <ng-container *rmaLet="googleReviewInsights$ as googleReviewInsights; suspenseRef: cardIsLoading">
                @if (googleReviewInsights?.convertedFromRmaReviewsCount > 0) {
                  <rma-my-subscription-google-card
                    [insights]="googleReviewInsights"
                    [profileOwnerName]="connectedGoogleAccountOwnerName$ | async"
                  />
                }
              </ng-container>
              <ng-template #cardIsLoading>
                <rma-my-subscription-is-loading-card />
              </ng-template>
            </div>
          </div>
        } @else {
          <div class="flex flex-col items-center gap-y-10 md:flex-row md:gap-x-10 md:gap-y-0">
            <div class="flex flex-col">
              <div class="flex gap-x-3">
                <rma-icon theme="discovery" glyph="rma-auto-awesome" />
                <span class="text-heading-2">{{ tloco('free-title') }}</span>
              </div>
              <span
                *rmaLet="potentialReviews$ as potentialReviews"
                class="mt-2"
                [innerHTML]="
                  potentialReviews > 0 ? tloco('free-subtitle', { reviewCount: potentialReviews }) : tloco('free-subtitle-no-review')
                "
              ></span>
              <div class="mt-6 flex gap-x-2 md:items-center">
                <rma-icon theme="primary" glyph="rma-reviews" />
                <span>{{ tloco('free-reviews') }}</span>
              </div>
              <div class="mt-3 flex gap-x-2 md:items-center">
                <rma-icon glyph="social-google-colour" />
                <span>{{ tloco('free-google') }}</span>
              </div>
              @if (platformIcon$ | async; as icon) {
                <div class="mt-3 flex gap-x-2 md:items-center">
                  <rma-icon [glyph]="icon" />
                  <span>{{ tloco('free-platforms') }}</span>
                </div>
              }
              <div class="mt-6 flex flex-col items-center gap-y-3 md:flex-row md:gap-x-6 md:gap-y-0">
                <a class="flex w-full flex-row-reverse gap-x-2 md:w-auto" color="accent" mat-flat-button routerLink="/billing/plans">
                  <span>{{ tloco('view-features') }}</span>
                  <rma-icon matButtonIcon glyph="call_made" />
                </a>
              </div>
            </div>
            @if (imagePath) {
              <img alt="" [src]="imagePath | staticImageUrl" />
            }
          </div>
        }
      </mat-card>
      @if (!subscription.isFree) {
        @if (productFeatures$ | async; as productFeatures) {
          <rma-my-subscription-feature-list class="mt-6 block" [productFeatures]="productFeatures" [subName]="subscription.name" />
        }
      }
      <mat-card class="mt-6 p-4 md:p-8">
        <span class="text-heading-2">{{ tloco('manage-subscription') }}</span>
        @if (showCancel$ | async) {
          <a class="mt-4 w-fit text-white" [routerLink]="unsubscribeUrl$ | async" mat-button color="warn">{{
            tloco('cancel-subscription')
          }}</a>
        } @else {
          @if (subscription.hasCancelled) {
            <span
              class="mt-2 mb-2"
              [innerHTML]="tloco('subscription-canceled', { subscriptionEnd: subscription.subscriptionEnd | date: 'd MMM y' })"
            ></span>
          }
          <div class="flex items-center gap-3">
            <a class="mt-4 w-fit" [disabled]="subscription.isFree" mat-stroked-button routerLink="/billing/plans" color="primary">{{
              tloco('change-subscription')
            }}</a>
            @if (showPauseSubscription$ | async) {
              <a class="mt-4 w-fit" mat-button routerLink="/billing/confirm-pause" color="primary">{{ tloco('pause-subscription') }}</a>
            }
          </div>
        }
      </mat-card>
    </div>
  }
</ng-container>
